export default [
  {
    path: '/roles',
    component: () => import('./UserRoles'),
    children: [
      {
        path: '/',
        name: 'RolePermissions',
        component: () => import('./role-permissions/RolePermissions')
      },
      {
        path: 'create',
        name: 'CreateUserRole',
        component: () => import('./UserRoleForm.vue')
      },
      {
        path: 'create/default',
        name: 'CreateDefaultRole',
        component: () => import('./UserRoleForm.vue')
      },
      {
        path: 'edit/:id',
        name: 'EditUserRole',
        component: () => import('./UserRoleForm.vue')
      },
      {
        path: 'edit/:id/default',
        name: 'EditDefaultRole',
        component: () => import('./UserRoleForm.vue')
      },
      {
        path: ':id',
        name: 'UserRoleDetails',
        component: () => import('./UserRoleDetails.vue')
      },
      {
        path: ':id/default',
        name: 'DefaultRoleDetails',
        component: () => import('./UserRoleDetails.vue')
      }
    ]
  },
  {
    path: '/defaultRoles',
    name: 'DefaultRolePermissions',
    component: () => import('./role-permissions/RolePermissions')
  }
]
